import {useCallback, useContext} from "react";
import {useQuery} from '@tanstack/react-query';
import useStaffUserLookup from "@components/common/hooks/useStaffUserLookup";
import {API_URLS, axiosRequest} from "@lib/axios";
import UserContext from "@lib/contexts/userContext";

/**
 * React Query wrapper for Session details
 */
const useEventDetailsQuery = (id) => {
  const { authenticated } = useContext(UserContext);
  const { usersLoading, setMetadataNames } = useStaffUserLookup();

  const select = useCallback((events) => {
    setMetadataNames(events);
    return events;
  }, [setMetadataNames]);

  return useQuery({
    queryKey: ['events', id ],
    queryFn: async () => axiosRequest({ method: 'GET', url: `${API_URLS.EVENTS}/${id}`}),
    enabled: authenticated && !usersLoading,
    select,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useEventDetailsQuery;
